import {
  CategoryUnionType,
  CompanyWithSitesMinifiedRowType,
  mapCompanyLinkCategoriesType,
  mapCompanySitesMinifiedType,
  mapPersonArtistsResponseType,
  mapPersonType,
  PersonArtistsType,
  PersonType,
  useFindCompanyLinkCategoriesSuspense,
  useFindCompanySitesMinifiedSuspense,
  useFindPersonArtistsSuspense,
  useFindPersonDetailsSuspense,
} from '@api';
import { Route } from 'src/routes/_rootLayout/persons/$id.general';

type UseCompanyLinksDataReturnType = {
  personDetails: PersonType;
  artists: PersonArtistsType[];
  companySites: CompanyWithSitesMinifiedRowType[];
  companyLinkCategories: CategoryUnionType[];
};

export const useCompanyLinksData = (): UseCompanyLinksDataReturnType => {
  const { id } = Route.useParams();
  const { data: personDetails } = useFindPersonDetailsSuspense(id, {
    query: { select: (data) => mapPersonType(data.data) },
  });
  const { data: artists } = useFindPersonArtistsSuspense(id, {
    query: { select: (data) => mapPersonArtistsResponseType(data?.data) },
  });
  const { data: companySites } = useFindCompanySitesMinifiedSuspense({
    query: {
      select: (data) => mapCompanySitesMinifiedType(data?.data),
    },
  });
  const { data: companyLinkCategories } = useFindCompanyLinkCategoriesSuspense({
    query: {
      select: (data) => mapCompanyLinkCategoriesType(data.data),
    },
  });

  return {
    personDetails,
    artists,
    companySites,
    companyLinkCategories,
  };
};
